import { Box, TextField } from '@hiiretail/react-foundation-ui';
import { EcoTaxResponse } from 'app/services/ecoTaxService/ecoTaxService.types';
import { Item } from 'app/services/itemsSearchService';
import { isPositiveNumber } from 'common/utils/isPositiveNumber';
import { DialogFormData } from 'common/receipt.types';
import { Control, Controller, FieldErrors } from 'react-hook-form';
import { IntlShape } from 'react-intl';
import get from 'lodash/get';
import { FormValues } from './addEditItem.typings';

type ItemFormStepProps = {
  prefix: 'parent' | `ecoTaxItems.${number}`;
  control: Control<FormValues>;
  errors: FieldErrors<FormValues>;
  intl: IntlShape;
  parentItem: Item | DialogFormData;
  ecoTaxData?: EcoTaxResponse;
  isParent: boolean;
};

const styles = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 2,
    mt: 2,
  },
};

export const ItemFormStep = ({
  prefix,
  control,
  errors,
  intl,
  parentItem,
  ecoTaxData,
  isParent,
}: ItemFormStepProps) => {

  const quantityError = get(errors, `${prefix}.quantity`);
  const unitPriceError = get(errors, `${prefix}.unitPrice`);
  const totalPriceError = get(errors, `${prefix}.totalPrice`);

  const required = intl.formatMessage({ id: 'receipt.input.required' });

  return (
    <Box sx={{ mt: 4 }}>
      <Box sx={styles.container}>
        <TextField
          InputProps={{ readOnly: true }}
          label={intl.formatMessage({ id: 'receipt.item.input.itemId' })}
          defaultValue={isParent ? parentItem.id : ecoTaxData?.id}
        />
        <TextField
          InputProps={{ readOnly: true }}
          label={intl.formatMessage({ id: 'receipt.item.input.name' })}
          defaultValue={isParent ? parentItem.name : ecoTaxData?.name}
        />
        <TextField
          InputProps={{ readOnly: true }}
          label={intl.formatMessage({ id: 'receipt.item.input.unitOfMeasure' })}
          defaultValue={parentItem.intlUnitOfMeasure}
        />
      </Box>
      <Box sx={styles.container}>
        <Controller
          name={`${prefix}.quantity`}
          control={control}
          rules={{
            required,
            validate: { isPositiveNumber },
          }}
          render={({ field }) => (
            <TextField
              label={intl.formatMessage({ id: 'receipt.item.input.quantity' })}
              type="number"
              {...field}
              error={!!quantityError}
              helperText={quantityError?.message}
            />
          )}
        />
        <Controller
          name={`${prefix}.unitPrice`}
          control={control}
          rules={{
            required,
            validate: { isPositiveNumber },
          }}
          render={({ field }) => (
            <TextField
              label={intl.formatMessage({ id: 'receipt.item.input.unitPrice' })}
              type="number"
              {...field}
              error={!!unitPriceError}
              helperText={unitPriceError?.message}
            />
          )}
        />
        <Controller
          name={`${prefix}.totalPrice`}
          control={control}
          rules={{
            required,
            validate: { isPositiveNumber },
          }}
          render={({ field }) => (
            <TextField
              label={intl.formatMessage({ id: 'receipt.item.input.totalPrice' })}
              type="number"
              {...field}
              error={!!totalPriceError}
              helperText={totalPriceError?.message}
            />
          )}
        />
      </Box>
    </Box>
  );
};
